/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Start_Tc_LabelInputs */



/**
* | output |
* | --- |
* | "Start timecode" |
*
* @param {Subtitle_Extract_Start_Tc_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_start_tc_label = /** @type {((inputs?: Subtitle_Extract_Start_Tc_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Start_Tc_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code temporel de début")
	if (locale === "de") return /** @type {LocalizedString} */ ("Startzeitcode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice temporale di inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начальный временной код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de tiempo de inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始タイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ समयकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de tempo inicial")
	return /** @type {LocalizedString} */ ("Start timecode")
});